import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

import { signin, getBrands } from '@/services/auth';
import { getUserSchedules } from '@/services/schedule';

export default new Vuex.Store({
  state: {
    current_brand: null,
    current_user: null,
    current_order: null,
    current_schedule: {
      service: null,
      office: null,
      specialist: null,
      date: null,
    },
    current_step: 0,
    current_title: '',
    appointments: [],
    loading_state: false,
    status: '',
  },
  mutations: {
    auth_request(state) {
      state.status = 'loading';
    },
    auth_success(state, data) {
      state.status = 'success';
      if (data) {
        state.current_user = data;
      }
    },
    auth_error(state) {
      state.status = 'error';
    },
    set_user_appointments(state, data) {
      state.appointments = data;
    },
    set_step(state, data) {
      state.current_step = data;
    },
    set_title(state, data) {
      state.current_title = data;
    },
    set_service(state, data) {
      state.current_schedule.service = data;
    },
    set_office(state, data) {
      state.current_schedule.office = data;
    },
    set_date(state, data) {
      state.current_schedule.date = data;
    },
    set_specialist(state, data) {
      state.current_schedule.specialist = data;
    },
    set_order(state, data) {
      state.current_order = data;
    },
    set_brand(state, data) {
      console.log(data, 'datadatadatadata');
      state.current_brand = data;
      state.current_brand.logo = require(`@/assets/images/logos/${process.env.VUE_APP_BRAND_ID}-logo.svg`);
      state.current_brand.background = require(`@/assets/images/backgrounds/${process.env.VUE_APP_BG_ID}-background.jpg`);
    },
    set_schedule(state, data) {
      state.current_schedule = {
        old_appointment_id: data.id,
        service: data.service,
        office: {
          region: data.branch.region,
          commune: data.branch.commune,
          office: data.branch,
        },
        specialist: null,
        date: {
          day: data.appointment_date,
          actual_time: data.appointment_time,
        },
      };
    },
    reset_current_schedule(state) {
      state.current_schedule = {
        service: null,
        office: null,
        specialist: null,
        date: null,
      };
    },
    reset_current_order(state) {
      state.current_step = 0;
      state.current_order = null;
    },
    reset_state(state) {
      state.current_user = null;
      state.current_order = null;
      state.current_schedule = {
        service: null,
        office: null,
        specialist: null,
        date: null,
      };
      state.current_step = 0;
      state.appointments = [];
      state.loading_state = false;
      state.status = '';
    },
  },
  actions: {
    setCurrentBrand({ commit }) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        getBrands()
          .then(response => {
            const brands = response.data.data;
            const current_brand = brands.find(
              o => o.code === process.env.VUE_APP_BRAND_ID,
            );
            console.log('+-------------------+');
            console.log(current_brand, 'current_brand');
            commit('set_brand', current_brand);
            commit('auth_success');
            resolve(current_brand);
          })
          .catch(error => {
            commit('auth_error');
            reject(error);
          });
      });
    },
    loginByScheduleId({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        signin(data)
          .then(response => {
            const appointment = response.data.data;
            const user = {
              user: {
                rut: appointment.contact_rut,
                firstname: appointment.contact_first_name,
                lastname: appointment.contact_last_name,
                phone: appointment.contact_phone,
                email: appointment.contact_email,
              },
              car: {
                brand: appointment.vehicle_model.brand,
                model: appointment.vehicle_model,
                license: appointment.license_plate,
                mileage: appointment.kms,
              },
            };
            commit('auth_success', user);
            commit('set_schedule', appointment);
            resolve(data);
          })
          .catch(error => {
            commit('auth_error');
            reject(error);
          });
      });
    },
    setCurrentSchedule({ commit }, data) {
      return new Promise(resolve => {
        commit('set_schedule', data);
        resolve();
      });
    },
    getUserAppoinments({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        getUserSchedules(state.current_user.user.rut)
          .then(response => {
            const appointments = response.data.data;
            commit('set_user_appointments', appointments);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    registerUser({ commit }, data) {
      return new Promise(resolve => {
        commit('auth_success', data);
        resolve(data);
      });
    },
    logoutUser({ commit }) {
      return new Promise(resolve => {
        commit('reset_state');
        resolve();
      });
    },
    setCurrentStep({ commit }, step) {
      return new Promise(resolve => {
        commit('set_step', step);
        resolve();
      });
    },
    setSelectedService({ commit }, data) {
      return new Promise(resolve => {
        commit('set_service', data);
        resolve(data);
      });
    },
    setSelectedOffice({ commit }, data) {
      return new Promise(resolve => {
        commit('set_office', data);
        resolve(data);
      });
    },
    setSelectedDate({ commit }, data) {
      return new Promise(resolve => {
        commit('set_date', data);
        resolve(data);
      });
    },
    setSelectedSpecialist({ commit }, data) {
      return new Promise(resolve => {
        const date = {
          day: data.day,
          hour: data.hour,
        };
        commit('set_date', date);
        commit('set_specialist', data.specialist);
        resolve(data);
      });
    },
    setOrder({ commit }, data) {
      return new Promise(resolve => {
        commit('reset_current_schedule');
        commit('set_order', data);
        resolve(data);
      });
    },
  },
  getters: {
    isLoggedIn: state => !!state.current_user,
    currentStep: state => state.current_step,
    hasFullSchedule: state =>
      !!(
        state.current_user &&
        state.current_brand &&
        state.current_schedule.date &&
        state.current_schedule.office &&
        state.current_schedule.service
      ),
    hasConfirmation: state =>
      !!(state.current_user && state.current_brand && state.current_order),
  },
  modules: {},
  plugins: [createPersistedState()],
});
